"use client";
import React, { useState } from "react";
import Image from "next/image";

interface FallbackImageProps {
  src: string;
  alt: string;
  fallbackSrc?: string;
  width?: number;
  height?: number;
  ariaLabel?: string;
  className?: string;
}

const FallbackImage: React.FC<FallbackImageProps> = ({
  src,
  alt,
  fallbackSrc = "/assets/images/no-image.jpg",
  width = 0,
  height = 0,
  ariaLabel,
  className,
}) => {
  const [imgSrc, setImgSrc] = useState(src);

  const handleError = () => {
    setImgSrc(fallbackSrc);
  };  
  const isMls =
    src.startsWith("/assets/images/listings/mls/") ||
    src.includes("/assets/images/listings/mls/");

  if (isMls) {
    return (
      <Image
        className={`w-100 h-auto ${className}`}
        sizes="100vw"
        src={imgSrc}
        alt={alt}
        onError={handleError}
        width={width}
        height={height}
        aria-label={ariaLabel}
        unoptimized
        // optional: avoid next/image loader rewriting
        loader={({ src }) => src}
      />
    );
  }

  return (
    <Image
      className={`w-100 h-auto ${className}`}
      sizes="100vw"
      src={imgSrc}
      alt={alt}
      onError={handleError}
      width={width}
      height={height}
      aria-label={ariaLabel}
      loader={({ src }) => src}
    />
  );
};

export default FallbackImage;
